import React from 'react';
import {useDispatch} from 'react-redux';

import {PIN} from 'web-app/react/components/pin/pin';
import AddPerson from 'web-app/react/components/icons/legacy/lazy-icons/add-person';
import useTypedSelector from 'web-app/react/hooks/use-typed-selector';

import * as Actions from './actions';
import * as Constants from './constants';

interface InputProps {
    onSubmit: (pin: string) => void;
    onAccountSelect: (selectedAccountId: string) => void;
}

const LoginPIN = (props: InputProps) => {
    const pin = useTypedSelector(state => state.login.pin);
    const pinState = useTypedSelector(state => state.login.pinState);
    const blockInput = useTypedSelector(state => state.login.challengeContext.show);

    const dispatch = useDispatch();

    const onChange = React.useCallback(
        (pin?: string) => {
            if (!blockInput) {
                dispatch(Actions.changePin.action(pin));
            }
        },
        [dispatch, blockInput],
    );

    const onAccountSelect = props.onAccountSelect;

    const contextualButton = React.useMemo(() => {
        return {
            icon: <AddPerson size={30} />,
            onClick: () => {
                onAccountSelect(Constants.NEW_ACCOUNT_IDENTIFIER);
            },
        };
    }, [onAccountSelect]);

    return (
        <PIN
            pinSize={4}
            onChange={onChange}
            onFinish={props.onSubmit}
            pinState={pinState}
            value={pin}
            contextualButton={contextualButton}
            withPills
        />
    );
};

export default LoginPIN;
